import React, { useState } from 'react'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import MusicPlayer from '../MusicPlayer'
import UserPlaylistPanel from '../UserPlaylistPanel'
import { useMusic } from '../../context/MusicContext'

export default function PlayerSection({
  bottomRef,
  playerRef,
  isExpanded,
  setIsExpanded,
}) {
  const { isPlayerOpen } = useMusic()
  const isVisible = isPlayerOpen
  const [isQueueOpen, setIsQueueOpen] = useState(false)

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={isVisible ? 'player-visible' : 'player-hidden'}
        timeout={200}
        classNames="slide"
        nodeRef={bottomRef}
      >
        {isVisible ? (
          <div ref={bottomRef} className="player-section-shell">
            {isQueueOpen ? (
              <div className="player-queue-panel-wrap">
                <UserPlaylistPanel />
              </div>
            ) : null}
            <div
              className={`content-bottom ${isVisible ? 'visible' : 'hidden'}`}
            >
              <MusicPlayer
                onExpand={() => setIsExpanded(!isExpanded)}
                onClose={() => setIsExpanded(false)}
                onToggleQueue={() => setIsQueueOpen((prev) => !prev)}
                isQueueOpen={isQueueOpen}
                isExpanded={isExpanded}
                ref={playerRef}
              />
            </div>
          </div>
        ) : (
          <div
            ref={bottomRef}
            className={`content-bottom ${isVisible ? 'visible' : 'hidden'}`}
          ></div>
        )}
      </CSSTransition>
    </SwitchTransition>
  )
}
